export const $context = Symbol('context');
export const $hasView = Symbol('hasView');
export const $instance = Symbol('instance');
export const $revision = Symbol('revision');
export const $shared = Symbol('shared');
export const $subview = Symbol('subview');
export var Priority;
(function(Priority) {
    Priority[Priority["Normal"] = 1] = "Normal";
    Priority[Priority["High"] = 2] = "High";
})(Priority || (Priority = {}));

//# sourceMappingURL=constants.js.map